// src/pages/Cliente/CadastrarEndereco.js
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './CadastrarEndereco.css'; // Importar o arquivo CSS externo.
import Header from '../../components/Form/Header';
import Footer from '../../components/Form/Footer';
import MainContent from '../../components/Form/MainContent';
import Input from '../../components/Input/Input';
import { useApi } from '../../hooks/useApi';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { formatCurrency } from '../../utils/numberUtils';
import { useTaxasEntregaBairro } from '../../hooks/useTaxasEntregaBairro';
import { reconciliarBairroEntrega } from '../../utils/enderecoEntregaUtils';
import { criarCorrecaoEndereco, limparCorrecaoEnderecoPedido } from '../../utils/CorrecaoEnderecoUtils';



const CadastrarEndereco = () => {
  const { fetchData, patchData } = useApi();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth(); // Usando o contexto para verificar autenticação
  const { configModulo } = useTheme();
  const usaTaxaEntregaBairro = configModulo?.taxaEntregaBairro === true;
  
  const [id, setId] = useState(0);
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [bairro, setBairro] = useState('');
  const [complemento, setComplemento] = useState('');
  const [cidadeId, setCidadeId] = useState(1);
  const [cidadesEntrega, setCidadesEntrega] = useState([]);
  const [taxaEntregaBairroId, setTaxaEntregaBairroId] = useState(null);
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState('');
  const enderecoInicialRef = useRef(null);
  const [carregandoEndereco, setCarregandoEndereco] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const {
    taxasEntregaBairro,
    carregandoTaxasBairro,
    erroTaxasBairro,
  } = useTaxasEntregaBairro(cidadeId, usaTaxaEntregaBairro);
  

  
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const endereco = await fetchData('/EnderecoApp'); // Faz o request para pegar o usuário
        if (!endereco) {
          enderecoInicialRef.current = {};
          setId(0);
          return;
        }
        enderecoInicialRef.current = endereco;
        setId(endereco.id);
        setLogradouro(endereco.logradouro);
        setNumero(endereco.numero);
        setBairro(endereco.bairro);
        setComplemento(endereco.complemento); 
        setCidadeId(endereco.cidadeId || 1);

      } catch (error) {
        console.error('Erro ao obter endereco:', error);
        setErrorMessage('Falha ao carregar os dados do usuário.');
      } finally {
        setCarregandoEndereco(false);
      }
    };

    const fetchCidadesEntrega = async () => {
      try {
        const result = await fetchData('/Cidade/CidadesDelivery');
        setCidadesEntrega(result);
        
      } catch (error) {
        console.log("Erro ao buscar tipos de entrega:" + error);
      }
    };

    // Se o usuário estiver autenticado, busca os dados do usuário
    if (isAuthenticated) {
      fetchUser();
      fetchCidadesEntrega();
    }


    if (location.state && location.state.endereco) {
      const { id, logradouro, numero, bairro, complemento, cidadeId: cidadeEnderecoId } = location.state.endereco; // Assume que o primeiro endereço deve ser editado
      setId(id);
      setLogradouro(logradouro);
      setNumero(numero);
      setBairro(bairro);
      setComplemento(complemento);  
      setCidadeId(cidadeEnderecoId || 1);
      enderecoInicialRef.current = location.state.endereco;
    }
  }, [isAuthenticated, location]);

  useEffect(() => {
    if (!usaTaxaEntregaBairro || !bairro || taxasEntregaBairro.length === 0) return;
    const taxa = reconciliarBairroEntrega({ cidadeId, bairro }, taxasEntregaBairro);
    setTaxaEntregaBairroId(taxa?.id || null);
  }, [usaTaxaEntregaBairro, bairro, cidadeId, taxasEntregaBairro]);

  const taxasBairroCidade = taxasEntregaBairro.filter((item) => Number(item.cidadeId) === Number(cidadeId));
  const taxaSelecionada = taxasEntregaBairro.find((item) => item.id === Number(taxaEntregaBairroId));

  const validateForm = () => {
    const newErrors = {};

    if (!logradouro) newErrors.logradouro = true;
    if (!numero) newErrors.numero = true;
    if (!bairro) newErrors.bairro = true;
    if (usaTaxaEntregaBairro && !taxaEntregaBairroId) newErrors.bairro = true;
    setErrors(newErrors);

    // Retorna true se não houver erros
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (carregandoEndereco || !enderecoInicialRef.current || salvando || !isAuthenticated) return;
    if (!validateForm()) {
      return;
    }

    const endereco = {
        id: id,
        //cliente: cliente, // Use clienteData em vez do estado
        //cliente: { id: 1 }, //TODO: ajustar para pegar o cliente da sessão
        logradouro,
        numero,
        bairro,
        cidadeId: parseInt(cidadeId),//por enquanto está fixo
        complemento
    };

    try {      

        setSalvando(true);
        let enderecoSalvo = endereco;
        if (id) {
          const campos = criarCorrecaoEndereco(enderecoInicialRef.current, endereco, ['logradouro', 'numero', 'bairro', 'complemento', 'cidadeId']);
          const response = Object.keys(campos).length ? await patchData('/EnderecoApp', campos) : endereco;
          enderecoSalvo = { ...endereco, ...response };
          // Se você precisa manipular a resposta de alguma forma, adicione aqui
          console.log("Resposta da API: ", response);
        } else {
          const campos = { logradouro, numero, bairro, complemento, cidadeId: Number(cidadeId) };
          const response = await patchData('/EnderecoApp', campos);
          enderecoSalvo = { ...endereco, ...response };
          // Se você precisa manipular a resposta de alguma forma, adicione aqui
          console.log("Resposta da API: ", response);       
        }
              
        if (taxaEntregaBairroId) localStorage.setItem('taxaEntregaBairroId', taxaEntregaBairroId);
        for (const campo of ['logradouro', 'numero', 'bairro', 'complemento', 'cidadeId']) localStorage.setItem(`${campo}Input`, enderecoSalvo[campo] ?? '');
        limparCorrecaoEnderecoPedido();
        navigate(-1);
    } catch (error) {
        console.error('Erro: ', error);
        setErrorMessage(error?.response?.data?.message || 'Não foi possível salvar o endereço. Tente novamente.');
    } finally {
        setSalvando(false);
    }
  };

  return (
    <>
      <Header titulo="Cadastrar Endereço" />
      <MainContent>
        <div className="formularioContainer">
        <fieldset disabled={carregandoEndereco || salvando} style={{ border: 0, padding: 0, margin: 0 }}>

        <select
            className="input"          
            value={cidadeId}
            onChange={(e) => {
              setCidadeId(e.target.value);
              if (usaTaxaEntregaBairro) {
                setBairro('');
                setTaxaEntregaBairroId(null);
              }
            }}
          >
            {/* <option value="">Todas as Cidades</option> */}
            {cidadesEntrega.map((cidade) => (
              <option key={cidade.id} value={cidade.id}>
                {cidade.nome}
              </option>
            ))}
          </select>

          <Input 
            type="text" 
            value={logradouro} 
            onChange={(e) => setLogradouro(e.target.value)} 
            placeholder="Rua" 
            error={errors.logradouro}
            />  
            
                              
          <Input 
            type="text" 
            value={numero} 
            onChange={(e) => setNumero(e.target.value)} 
            placeholder="Número"  
            error={errors.numero}
          />
          {usaTaxaEntregaBairro ? (
            <>
              <select
                className={`input ${errors.bairro ? 'input-error' : ''}`}
                value={taxaEntregaBairroId || ''}
                disabled={carregandoTaxasBairro || !!erroTaxasBairro}
                onChange={(e) => {
                  const idTaxa = Number(e.target.value) || null;
                  const taxa = taxasEntregaBairro.find((item) => item.id === idTaxa);
                  setTaxaEntregaBairroId(idTaxa);
                  setBairro(taxa?.descricao || '');
                  setErrors((prev) => ({ ...prev, bairro: false }));
                }}
              >
                <option value="">
                  {carregandoTaxasBairro
                    ? 'Carregando bairros...'
                    : taxasBairroCidade.length === 0
                      ? 'Nenhum bairro cadastrado'
                      : 'Selecione o bairro'}
                </option>
                {taxasBairroCidade.map((taxa) => <option key={taxa.id} value={taxa.id}>{taxa.descricao}</option>)}
              </select>
              {erroTaxasBairro && <div className="endereco-bairro-feedback erro">{erroTaxasBairro}</div>}
              {taxaSelecionada && <div className="endereco-taxa-bairro">Taxa de entrega: <strong>{formatCurrency(taxaSelecionada.valor)}</strong></div>}
            </>
          ) : (
            <Input
              type="text"
              value={bairro}
              onChange={(e) => setBairro(e.target.value)}
              placeholder="Bairro"
              error={errors.bairro}
            />
          )}
          <Input 
            type="text" 
            value={complemento} 
            onChange={(e) => setComplemento(e.target.value)} 
            placeholder="Complemento" 
          />
          {errorMessage && <p role="alert">{errorMessage}</p>}
          <button onClick={handleSave} className="button" disabled={carregandoEndereco || !enderecoInicialRef.current || salvando}>{salvando ? 'Aguarde...' : 'Salvar Endereço'}</button>
        </fieldset>
        </div>
      </MainContent>
      <Footer />
    </>
  );
};

export default CadastrarEndereco;
